import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import logo from "../assets2/images/whiteLogo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
	IoMdArrowDropdown,
	IoMdArrowDropup,
	IoMdHeartEmpty,
} from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import Box from "@mui/material/Box";
import profileIcon from "../assets/images/userres.svg";
import profileIcon2 from "../assets/images/downres.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { FiMenu } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import NavPopup from "./shared/NavPopup";
import Modal from "./shared/Modal";
import SignUpModal from "././SignUpModal";
import LoginModal from "././LoginModal";
import SocialModal from "././SocialModal";
import AdditionalDetails from "././AdditionalDetails";
import CheckInboxModal from "././CheckInboxModal";
import LogoutModal from "././LogoutModal";
import {
	toggleExplore,
	toggleMobileExplore,
	setHoveredOption,
	setActiveSubOption,
	toggleNav,
	togglePopup,
	toggleSignUp,
	toggleLogin,
	toggleSocial,
	toggleAdditional,
	toggleCheckInbox,
	closeModals,
	toggleReset,
	toggleLogoutModal,
} from "../store/features/modalSlice";
import { clearUser } from "../store/features/authSlice";
import ResetPassword from "./forget-password/ResetPassword";
import ResetMailSend from "./forget-password/ResetMailSent";
import ResetWorkMail from "./forget-password/ResetWorkMail";
import PasswordUpdated from "./forget-password/PasswordUpdated";
import { resetFormData } from "../store/features/authSlice";
import Cookies from "js-cookie";
import MobileNavigation from "./navbar/MobileNavigation";
import { getURLParams } from "../utils/utilityFunctions";

const NavbarCustomer = ({ filters, setFilters }) => {
	console.log("NAVBAR CUSTOMER");
	const dispatch = useDispatch();
	const [subOption, setSubOption] = useState(null);
	const [anchorElProfile, setAnchorElProfile] = useState(null);
	const location = useLocation();
	const navigate = useNavigate();
	// const vendorId = localStorage.getItem("vendorId");
	const [vendorId, setVendorId] = useState(null);
	const isLoggedIn = !!localStorage.getItem("accessToken");
	const [encryptedMail, setEncryptedMail] = useState("");
	const {
		openExplore,
		openMobileExplore,
		hoveredOption,
		activeSubOption,
		openNav,
		openPopup,
		selectedSubOptions,
		selectedName,
		showSignUp,
		showLogin,
		showReset,
		showSocial,
		resetWorkMail,
		showAdditional,
		showCheckInbox,
		resetMailSend,
		updatePassword,
		showLogoutModal,
	} = useSelector((state) => state.modal);

	const { user } = useSelector((state) => state.auth);
	const dropdownRef = useRef(null);
	const isFirstRun = useRef(true);

	const startOptions = [
		{
			name: "Celebrations",
			filterKey: "eventTypes",
			subKey: [
				"Weddings",
				"Weddings",
				"Dining",
				"Social Gathering",
				"Dining",
				"Social Gathering",
				"Milestone Birthdays",
				"Tea Party/Showers",
				"Tea Party/Showers",
				"Teen/Children",
				"Special Big Events",
				"Cultural Celebrations",
			],
			subOptions: [
				"Wedding Ceremony",
				"Wedding Reception",
				"Anniversary Party",
				"Engagement",
				"Graduation Party",
				"New Years Eve Party",
				"Birthday Party",
				"Baby Shower",
				"Bridal Shower",
				"Teen Party",
				"Gender Reveals",
				"Christmas Party",
				// "Cultural Celeberations",
			],
		},
		{
			name: "Art & Culture",
			filterKey: "eventTypes",
			subKey: [
				"Filming, Photography & Media",
				"Art Spaces",
				"Art Spaces",
				"Performances & Exhibitions",
				"Performances & Exhibitions",
				"Performances & Exhibitions",
			],
			subOptions: [
				"Photoshoot",
				"Art Exhibitions",
				"Pop Up Event",
				"Concert",
				"Fashion Show",
				"Live Performance",
			],
		},
		{
			name: "Corporate",
			filterKey: "eventTypes",
			subKey: [
				"Conference/Seminars",
				"Conference/Seminars",
				"Conference/Seminars",
				"Conference/Seminars",
				"Conference/Seminars",
				"Corporate Events",
				"Corporate Events",
				"Corporate Events",
				"Corporate Events",
				"Corporate Events",
			],
			subOptions: [
				"Conference",
				"Exhibitions",
				"Meetings",
				"Networking",
				"Product Launch",
				"Team Building",
				"Training Program",
				"Office Party",
				"Corporate Gala Dinner",
				"Corporate Retreat",
			],
		},
		{
			name: "City",
			filterKey: "city",
			subOptions: [
				"Dubai",
				"Abu Dhabi",
				"Ras Al Khaimah",
				"Sharjah",
				"Fujairah",
				"Ajman",
				"Umm Al Quwain",
			],
		},
		{
			name: "Venue Type",
			filterKey: "venueTypes",
			subOptions: [
				"Beach",
				"Desert",
				"Boats & Yachts",
				"Venue with onsite activities",
				"Sports venue",
				"Exhibitions Halls",
				"Meeting room",
				"Kids play area",
				"Restaurant",
				"Ballroom",
				"Blank canvas",
				"Auditorium",
				"Warehouse",
				"Indoor",
				"Outdoor",
				"Indoor & Outdoor",
			],
		},
		{
			name: "Hotel Stay + Venue",
			filterKey: "hotelStayAndVenue",
			subOptions: [
				"Airport Hotel",
				"All-Inclusive Resort",
				"Beach Hotel",
				"Boutique Hotel",
				"Budget Hotel",
				"Business Hotel",
				"Casino Hotel",
				"City Hotel",
				"Desert Hotel",
				"Eco-friendly Hotel",
				"Floating Hotel",
				"Glamping Hotel",
				"Golf Resorts",
				"Heritage Hotel",
				"Historic Hotel",
				"Island Hotel",
				"Luxury Hotel",
				"Resort Hotel",
				"Safari Hotel",
				"Wellness Hotel",
			],
		},
	];
	const handleOpenProfileMenu = (event) => {
		setAnchorElProfile(event.currentTarget);
	};

	const handleCloseProfileMenu = () => {
		setAnchorElProfile(null);
	};

	const handleLogout = () => {
		Cookies.remove("token", { path: "/" });
		localStorage.clear();
		dispatch(clearUser());
		navigate("/");
	};

	useEffect(() => {
		// Add event listener to close Explore when clicking outside
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target) &&
				openExplore // Only close if open
			) {
				dispatch(toggleExplore());
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [dispatch, openExplore]);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const emailParam = queryParams.get("email");

		// If email exists in the query, dispatch toggleReset to open the reset password modal
		if (emailParam) {
			const decryptMail = window.atob(emailParam);
			setEncryptedMail(decryptMail);
			dispatch(toggleReset());
		}
	}, [location, dispatch]);

	useEffect(() => {
		setVendorId(localStorage.getItem("vendorId"));

		window.addEventListener("storage", () =>
			setVendorId(localStorage.getItem("vendorId"))
		);
		return () =>
			window.removeEventListener(
				"storage",
				setVendorId(localStorage.getItem("vendorId"))
			);
	}, []);

	const handleSelectOption = (category, option) => {
		setFilters((prevFilters) => {
			let newFilters;

			if (category === "hotelStayAndVenue") {
				newFilters = { ...prevFilters, hotelType: [option] };
			} else if (category === "eventTypes") {
				newFilters = { ...prevFilters, eventTypes: option };
			} else {
				newFilters = { ...prevFilters, [category]: [option] };
			}

			dispatch(setHoveredOption(null));
			dispatch(setActiveSubOption(null));
			dispatch(toggleExplore());

			if (isFirstRun.current) {
				isFirstRun.current = false;
			} else {
				if (category === "hotelStayAndVenue") {
					navigate(`/listing/2?${getURLParams(newFilters)}`, {
						replace: false,
					});
				} else {
					navigate(`/listing/1?${getURLParams(newFilters)}`, {
						replace: false,
					});
				}
			}

			return newFilters;
		});
	};

	const handleToggleNavigation = () => {
		dispatch(toggleNav());
		if (openPopup) dispatch(togglePopup({ isOpen: false }));
		if (openMobileExplore) dispatch(toggleMobileExplore());
	};

	const isHomePage = location.pathname === "/";
	return (
		<div
			className={`bg-primary flex justify-center w-full py-3 z-50 ${openNav ? "fixed top-0 left-0" : ""
				}`}
		>
			<div className="w-[90%] flex justify-between items-center cursor-pointer">
				{/* <div>
					{!isHomePage ? (
						<Link to={"/"}>
							<img alt="Logo" src={logo} />
						</Link>
					) : (
						<img alt="Logo" src={logo} />
					)}
				</div> */}
				<a
					href="/"
				>
					<img src={logo} alt="Dashboard" className="w-full" />
				</a>

				<div
					className={`lg:flex hidden items-center relative ${isLoggedIn ? "gap-3" : "gap-8"
						}`}
					ref={dropdownRef}
				>
					<div
						className="sm:flex hidden items-center gap-2 cursor-pointer"
						onClick={() => dispatch(toggleExplore())}
					>
						<h1 className="text-white">Explore</h1>
						{openExplore ? (
							<IoMdArrowDropup className="text-white text-lg" />
						) : (
							<IoMdArrowDropdown className="text-white text-lg" />
						)}
						{openExplore && (
							<div
								className="bg-white rounded-lg z-50 absolute top-9 left-0 shadow-xl p-2 min-w-[200px]"
								onMouseLeave={() => {
									dispatch(setHoveredOption(null));
									dispatch(setActiveSubOption(null));
								}}
							>
								{startOptions.map((e, i) => (
									<div
										key={i}
										className="relative"
										onMouseEnter={() => {
											dispatch(setHoveredOption(i));
											dispatch(setActiveSubOption(i));
										}}
									>
										<div
											className={`py-2 px-2 w-full flex-1 text-sm flex items-center justify-between gap-2 rounded-md hover:bg-[#FFF5F5] ${hoveredOption === i ? "bg-[#FFF5F5]" : ""
												}`}
										>
											{e.name}
											{e.subOptions && (
												<MdOutlineKeyboardArrowRight className="text-lg flex-shrink-0" />
											)}
										</div>

										{(activeSubOption === i || hoveredOption === i) &&
											e.subOptions && (
												<div
													className={`bg-white rounded-md absolute right-full top-0 mr-1 overflow-y-auto max-h-[80vh] grid ${i === 1
														? "grid-cols-2 xl:w-[32rem] w-[28rem]"
														: i === 0
															? "grid-cols-2 xl:w-[22rem] w-[20rem]"
															: i === 4
																? "grid-cols-2 xl:w-[32rem] w-[28rem]"
																: "grid-cols-2 xl:w-[22rem] w-[20rem]"
														} shadow-lg z-[51]`} // Higher z-index than parent
													onMouseEnter={() => {
														dispatch(setHoveredOption(i));
														dispatch(setActiveSubOption(i));
													}}
													onMouseLeave={() => {
														dispatch(setHoveredOption(null));
														dispatch(setActiveSubOption(null));
													}}
												>
													{e.subOptions.map((subOption, subIndex) => (
														<div
															key={subIndex}
															className="px-4 py-3 rounded-md text-sm hover:bg-[#FFF0F0] cursor-pointer whitespace-nowrap"
															onClick={() => {
																setFilters({
																	search: "",
																	city: "",
																	eventTypes: [],
																	venueTypes: [],
																	venueHire: [],
																	standingGuests: "",
																	sittingGuests: "",
																	catering: [],
																	venueSettings: [],
																	amenities: [],
																	menus: [],
																	area: [],
																	venueRental: { min: "", max: "" },
																	minSpendPerPerson: { min: "", max: "" },
																	minSpendPerEvent: { min: "", max: "" },
																});

																if (e.filterKey === "eventTypes") {
																	const subKeyValue =
																		startOptions[i].subKey[subIndex];
																	setSubOption(
																		startOptions[i].subKey[subIndex]
																	);
																	handleSelectOption(e.filterKey, {
																		[subKeyValue]: [subOption],
																	});
																} else {
																	handleSelectOption(e.filterKey, subOption);
																}
															}}
														>
															{subOption}
														</div>
													))}
												</div>
											)}
									</div>
								))}
							</div>
						)}
					</div>

					{user && (
						<Link to="/my-favorites" className="text-white hidden sm:flex  ">
							<div className="flex justify-center items-center gap-1">
								<IoMdHeartEmpty size={24} /> <span>My Favorites</span>
							</div>
						</Link>
					)}

					{user && (
						<Link to="/enquiries" className="text-white hidden sm:flex  ">
							<div className="flex justify-center items-center gap-1">
								<IoDocumentTextOutline size={24} /> <span>My Enquiries</span>
							</div>
						</Link>
					)}

					{!user && !vendorId ? (
						<>
							{/* <button
								onClick={() => {
									navigate("/user-login");
								}}
								className="text-white"
							>
								Login
							</button> */}
							<button
								onClick={() => {
									navigate("/login");
								}}
								className="hidden lg:block text-white"
							>
								Login/Signup
							</button>
						</>
					) : (
						<div>
							{!vendorId && (
								<div className="flex items-center gap-x-2">
									{user?.profilePic ? (
										<>
											<div className="relative w-8 h-8 overflow-hidden bg-[#cccccc] rounded-full ">
												<img src={user?.profilePic} alt="" />
											</div>
										</>
									) : (
										<>
											<div className="relative w-8 h-8 overflow-hidden bg-[#cccccc] rounded-full ">
												<svg
													className="absolute w-10 h-10 text-[#ffff] -left-1"
													fill="currentColor"
													viewBox="0 0 20 20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
														clipRule="evenodd"
													></path>
												</svg>
											</div>
										</>
									)}

									<IoMdArrowDropdown
										className="text-white text-lg cursor-pointer"
										onClick={() => dispatch(toggleLogoutModal())}
									/>
								</div>
							)}
						</div>
					)}

					{isLoggedIn && (
						<Box
							sx={{ display: { md: "flex" }, alignItems: "center", zIndex: 10 }}
						>
							<IconButton onClick={handleOpenProfileMenu} sx={{ zIndex: 10 }}>
								<Box
									component="img"
									src={profileIcon}
									alt="profile"
									sx={{ height: 45, width: 45 }}
								/>
								<Box
									component="img"
									src={profileIcon2}
									alt="profile"
									className="ml-3"
								/>
							</IconButton>
							<Menu
								anchorEl={anchorElProfile}
								open={Boolean(anchorElProfile)}
								onClose={handleCloseProfileMenu}
								sx={{ zIndex: 11 }}
							>
								<MenuItem onClick={handleLogout}>Log Out</MenuItem>
							</Menu>
						</Box>
					)}
				</div>

				<button
					className="lg:hidden block px-2"
					onClick={handleToggleNavigation}
				>
					{openNav ? (
						<RxCross2 className="text-white text-3xl" />
					) : (
						<FiMenu className="text-white text-3xl" />
					)}
				</button>

				<MobileNavigation handleLogout={handleLogout} />
			</div>

			<NavPopup
				openPopup={openPopup}
				onClose={() => dispatch(togglePopup({ isOpen: false }))}
				subOptions={selectedSubOptions}
				selectedName={selectedName}
				startOptions={startOptions}
				handleToggleNavigation={handleToggleNavigation}
				setFilters={setFilters}
			/>

			<LogoutModal isOpen={showLogoutModal} />

			<Modal
				isOpen={showSignUp}
				onClose={() => {
					dispatch(closeModals());
					dispatch(resetFormData());
				}}
				label="Sign up"
			>
				<SignUpModal
					setShowSignUp={() => {
						navigate("/user-signup");
					}}
					onLoginClick={() => {
						navigate("/user-login");
						dispatch(resetFormData());
					}}
					onSubmit={() => dispatch(toggleCheckInbox())}
					onSocialClick={() => dispatch(toggleSocial())}
				/>
			</Modal>

			<Modal
				isOpen={showLogin}
				onClose={() => {
					dispatch(closeModals());
					dispatch(resetFormData());
				}}
				label="Log in"
			>
				<LoginModal
					onSignUpClick={() => {
						navigate("/user-signup");
					}}
					onSubmit={() => dispatch(closeModals())}
					onSocialClick={() => dispatch(toggleSocial())}
				/>
			</Modal>

			<Modal
				isOpen={showReset}
				onClose={() => dispatch(closeModals())}
				label="Reset Password"
			>
				<ResetPassword
					onSubmit={() => dispatch(closeModals())}
					mail={encryptedMail}
				/>
			</Modal>
			<Modal
				isOpen={updatePassword}
				onClose={() => dispatch(closeModals())}
			// label="Reset Password"
			>
				<PasswordUpdated
					onSubmit={() => dispatch(closeModals())}
					mail={encryptedMail}
				/>
			</Modal>

			<Modal
				isOpen={resetMailSend}
				onClose={() => dispatch(closeModals())}
			// label="Reset Password Email Sent"
			>
				<ResetMailSend onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={resetWorkMail}
				onClose={() => dispatch(closeModals())}
				label="Reset Password"
			>
				<ResetWorkMail onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={resetMailSend}
				onClose={() => dispatch(closeModals())}
			// label="Reset Password Email Sent"
			>
				<ResetMailSend onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={showSocial}
				onClose={() => dispatch(closeModals())}
				label=""
			>
				<SocialModal
					onLoginClick={() => {
						navigate("/user-login");
					}}
					onAdditionalClick={() => dispatch(toggleAdditional())}
				/>
			</Modal>

			<Modal
				isOpen={showAdditional}
				onClose={() => dispatch(closeModals())}
				label="Additional Details"
				isCloseBtnDisable={true}
			>
				<AdditionalDetails onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={showCheckInbox}
				onClose={() => dispatch(closeModals())}
				label=""
			>
				<CheckInboxModal onClose={() => dispatch(closeModals())} />
			</Modal>
		</div>
	);
};

export default NavbarCustomer;
